import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
// import { Fields, Options } from '../../../../models/genmodel';
import { Fields, Options } from 'src/app/shared/models/genmodel';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ElementRef, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { HttpClient } from '@angular/common/http';
import { GenModelService } from 'src/app/core/services/gen-model.service';
import { KeyValuePair } from 'src/app/shared/models/keyvaluepairModel';

@Component({
  selector: 'app-chipfullwidth',
  templateUrl: './chipfullwidth.component.html',
  styleUrls: ['./chipfullwidth.component.scss'],
  standalone: false,
})
export class ChipfullwidthComponent implements OnInit {
  field: Fields;
  group: UntypedFormGroup;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  chipCtrl = new UntypedFormControl();
  filteredChips: KeyValuePair[];
  chips: KeyValuePair[] = [];
  selectedChip = [];

  @ViewChild('chipInput') chipInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  constructor(
    private http: HttpClient,
    private genModelService: GenModelService,
  ) {
    this.chipCtrl.valueChanges.subscribe((data: string) => this._filter(data, this.field.url));
  }

  ngOnInit() {
    // console.log(this.group);
    // console.log(this.field.validations);
    // const data = this.field["value"];
    // console.log(data);

    this.genModelService.resetChipEvent.subscribe(() => {
      this.chips = [];
      this.selectedChip = [];
    });

    if (this.field.options && this.field.options.length > 0) {
      this.field.options.forEach((element) => {
        // console.log('here');
        this.chips.push(element);
        this.selectedChip.push(element.key);
      });
      this.group.get(this.field.name).setValue(this.selectedChip);
    }
    // console.log("this.chips", this.chips);
    else {
      this.chips = [];
    }
  }

  // setValueInTooltip(skillName: string) {
  //   if (skillName.length > 47) return skillName;
  //   else return null;
  // }

  add(event: MatChipInputEvent): void {
    // Add Chips only when MatAutocomplete is not open
    // To make sure this does not conflict with OptionSelected Event
    if (!this.matAutocomplete.isOpen) {
      const input = event.input;
      const value = event.value;
      if (this.filteredChips) {
        const data = this.filteredChips.find((x) => x.value == value);

        //  data.selected = true;
        // Add our Chip
        if (data) {
          if ((value || '').trim()) {
            this.chips.push(data);
            // this.group[this.field.name].setValue(this.chips);
          }
        }

        // Reset the input value
        if (input) {
          input.value = '';
        }
      }
      this.chipCtrl.setValue(null);
    }
  }

  remove(chip: Options): void {
    // console.log("chip -- ", chip)
    const index = this.chips.indexOf(chip);

    if (index >= 0) {
      this.chips.splice(index, 1);
      this.selectedChip.splice(index, 1);
    }
    // this.selectedChip.forEach((value, index) => {
    //   if (value === chip.key) {
    //     this.selectedChip.splice(index, 1)
    //   }
    // });
    // console.log(this.chips);
    // console.log(this.selectedChip);
    this.group.get(this.field.name).setValue(this.selectedChip);
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const selectedVal = this.filteredChips.find((res) => res.value === event.option.value);
    let flag: boolean = true;
    if (this.selectedChip.length > 0) {
      for (const ckey of this.selectedChip) {
        if (ckey == selectedVal.key) {
          flag = false;
          break;
        }
      }
      if (flag) {
        this.selectedChip.push(selectedVal.key);
        this.group.get(this.field.name).setValue(this.selectedChip);
        this.genModelService.setSkillData(this.selectedChip);
        // console.log("this.selectedChip", this.selectedChip);
        this.chips.push(event.option);
        // console.log("event.option", event.option);
        this.chipInput.nativeElement.value = '';
        this.chipCtrl.setValue(null);
        // console.log("chipCtrl---", this.chipCtrl)
      }
    } else {
      this.selectedChip.push(selectedVal.key);
      this.group.get(this.field.name).setValue(this.selectedChip);
      this.genModelService.setSkillData(this.selectedChip);
      // console.log("this.selectedChip", this.selectedChip);
      this.chips.push(event.option);
      // console.log("event.option", event.option);
      this.chipInput.nativeElement.value = '';
      this.chipCtrl.setValue(null);
      // console.log("chipCtrl---", this.chipCtrl)
    }
    // this.selectedChip.push(selectedVal.key)
    // this.group.get(this.field.name).setValue(this.selectedChip);
    // console.log("this.selectedChip", this.selectedChip);
    // this.chips.push(event.option);
    // console.log("event.option", event.option);
    // this.chipInput.nativeElement.value = '';
    // this.chipCtrl.setValue(null);
    // console.log("chipCtrl---", this.chipCtrl)
  }

  // private _filter(value: string): string[] {
  //   const filterValue = value.toLowerCase();

  //   return this.f.filter(chips => chips.toLowerCase().indexOf(filterValue) === 0);
  // }

  private _filter(value, url) {
    if (value !== null && value !== '') {
      const filterValue = value.toLowerCase();
      if (this.field.url === null) {
        this.filteredChips = this.field.options.filter((option) => option.value.toLowerCase().includes(filterValue));
        this.group.get(this.field.name).setErrors({ error: true });
      } else {
        this.getFilterData(url, filterValue).subscribe((x) => {
          const temp = [];
          x.forEach((res, _key) => {
            temp.push({ key: res['skill_id'], value: res['skill_name'] });
          });
          this.filteredChips = temp;
        });
      }
    } else {
      this.filteredChips = [];
    }
  }
  getFilterData(url, value) {
    return this.http.get<KeyValuePair[]>(url + value);
  }
}
